import { AxiosResponse } from 'axios'
import Request from 'redux/config/services/Request'

const getSsoCompanies = (): Promise<AxiosResponse> => {
  return Request.get('/sso/companies/')
}

export { getSsoCompanies }
